import * as types from './actionTypes';
import api from '../../../api/';


export function addBookmark(data) {
  // body...
  return async (dispatch) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const bookmarks = await api.addBookmarkToBoard(data);

      dispatch({
        type: types.LOADED,
        bookmarks,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
